<div class="wrapper">
  <app-main-menu></app-main-menu>
  <div class="content">
    <router-outlet></router-outlet>
  </div>
</div>
<app-footer></app-footer>
@if (message) {
  <div class="alert-message" [class]="message.severity">
    <ods-icon variant="close" class="close" (click)="closeMessage()"></ods-icon>
    <div class="alert-message-content">
      <h2><ods-icon variant="error"></ods-icon></h2>
      <div>
        <h2>{{ message.summary }}</h2>
        <p>{{ message.detail }}</p>
      </div>
    </div>
  </div>
}
@if (isShowRenewalPopup) {
  <app-renewal-popup [userProfile]="userProfile"></app-renewal-popup>
}
@if (showLoader) {
  <app-loader></app-loader>
}
